// @flow

// lib
import React, { PureComponent } from 'react';
import {
  Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import { connect } from 'dva';

// component
import Container from './components/Layout/Container';

import Footer from './components/Layout/Footer';

import CONFIG from './config.json';

// utils
import { history } from './utils/router';
import { env, mtopInjection } from './utils';

// style
import './styles/style.less';

const EnvBadge = () => {
  const _env = [
    [env.isDev, 'dev', '开发'],
    [env.isDaily, 'daily', '日常'],
    [env.isPre, 'pre', '预发'],
  ].filter(ele => ele[0]())[0];
  return !!_env && <sup className={`ap-env-badge ap-${_env[1]}`}>{_env[2]}</sup>
};
@connect()

export default class App extends PureComponent {
  componentDidMount() {
    window.sessionStorage.setItem(CONFIG.APP_ID, JSON.stringify({
      token: window.YLB_CONFIG.token,
      tb_eagleeyex_scm_project: window.YLB_CONFIG.tb_eagleeyex_scm_project,
    }));
    mtopInjection(null, null, window.YLB_CONFIG.token, window.YLB_CONFIG.tb_eagleeyex_scm_project); // 注入token  // tb_eagleeyex_scm_project 隔离环境，以后可能删除
    this.props.dispatch({
      type: 'accountRegister/getRegisterStatus'
    })
  }
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Redirect exact from="/" to="/welcome/home"/>
          <Redirect from="/checkAdmission" to="/welcome/home"/>
          <Route render={() => (
            <div className="ap-app">
              {/* <Header
                logo={
                  <span
                    className="ap-header-platform"
                    onClick={() => { window.location.href = '/'; } }
                  >
                项目名称<EnvBadge />
              </span>
                }
                user={<span>{this.props.user.loginName}</span>}
                menu={[{
                  text: '退出',
                  action: this.props.userLogout,
                }]}
              />
              <Sider routes={routes}/> */}
              <div className="ap-container">
                {/* <Breadcrumb routes={routes}/> */}
                <div className="ap-content">
                  <Container />
                </div>
                <Footer />
              </div>
            </div>
          )}
          />
        </Switch>
      </Router>
    );
  }
}

/*
export default connect(state => ({
  user: state.common.user,
}), dispatch => ({
  userLogin: bindActionCreators(userLoginRequest, dispatch),
  userLogout: bindActionCreators(userLogoutRequest, dispatch),
  userPersistence: bindActionCreators(userPersistenceRequest, dispatch),
}))(App);
*/



// WEBPACK FOOTER //
// ./src/App.js